import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { HeadersHttpService } from '#utils/http-headers/http-headers.service';

@Injectable({ providedIn: 'root' })
export class ChatHttpService {
    private baseUrl = environment.baseUrl + 'Chat/';

    constructor(
        private http: HttpClient,
        private headerService: HeadersHttpService
    ) {}

    getActiveSessions(): Observable<any> {
        return this.http.get(this.baseUrl + 'GetActiveSessions', {
            headers: this.headerService.getHeadersPrivate(),
        });
    }

    getMessages(chatSessionId: number): Observable<any> {
        return this.http.get(
            this.baseUrl + 'GetMessages/' + chatSessionId,
            { headers: this.headerService.getHeadersPrivate() }
        );
    }

    sendMessage(data: {
        chatSessionId: number;
        content: string;
        senderType: string;
        senderAdminUserId: string;
        senderName: string;
        sessionIdentifier: string;
    }): Observable<any> {
        return this.http.post(this.baseUrl + 'SendMessage', data, {
            headers: this.headerService.getHeadersPrivate(),
        });
    }

    assignAdmin(data: {
        chatSessionId: number;
        adminUserId: string;
    }): Observable<any> {
        return this.http.put(this.baseUrl + 'AssignAdmin', data, {
            headers: this.headerService.getHeadersPrivate(),
        });
    }

    closeSession(chatSessionId: number): Observable<any> {
        return this.http.put(
            this.baseUrl + 'CloseSession',
            { chatSessionId },
            { headers: this.headerService.getHeadersPrivate() }
        );
    }

    markRead(chatSessionId: number): Observable<any> {
        return this.http.put(
            this.baseUrl + 'MarkRead',
            { chatSessionId, readerType: 'admin' },
            { headers: this.headerService.getHeadersPrivate() }
        );
    }
}
